(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function updateSoundBtn(btn, muted) {
      var iconOff = btn.querySelector('.pb-expert-card__sound-icon--off');
      var iconOn  = btn.querySelector('.pb-expert-card__sound-icon--on');
      if (muted) {
        iconOff.hidden = false;
        iconOn.hidden  = true;
        btn.setAttribute('aria-label', 'Geluid aanzetten');
      } else {
        iconOff.hidden = true;
        iconOn.hidden  = false;
        btn.setAttribute('aria-label', 'Geluid uitzetten');
      }
    }

    function initExpertCards() {
      var sections = document.querySelectorAll('.pb-experts');

      sections.forEach(function (section) {
        var cards  = section.querySelectorAll('[data-pb-video-card]');
        var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

        cards.forEach(function (card) {
          var video     = card.querySelector('.pb-expert-card__video');
          var soundBtn  = card.querySelector('[data-pb-sound-btn]');
          if (!video) return;

          /* Video start altijd gedempt — browser staat dit altijd toe */
          video.muted = true;

          /* Initialiseer knop-icoon */
          if (soundBtn) updateSoundBtn(soundBtn, true);

          function startPlay() {
            card.classList.add('pb-expert-card--playing');
            video.play().catch(function () {});
          }

          function stopPlay() {
            card.classList.remove('pb-expert-card--playing');
            /* Geluid dempen voor de volgende keer */
            video.muted = true;
            if (soundBtn) updateSoundBtn(soundBtn, true);
            video.pause();
            video.currentTime = 0;
          }

          /* Geluidknop: echte klik → browser laat geluid toe */
          if (soundBtn) {
            soundBtn.addEventListener('click', function (e) {
              e.stopPropagation(); /* Voorkomt dat de kaart-click ook afgaat op touch */
              video.muted = !video.muted;
              updateSoundBtn(soundBtn, video.muted);
            });
          }

          if (isTouch) {
            /* Touch: eerste tap = play, tweede tap = stop */
            card.addEventListener('click', function (e) {
              /* Klik op geluidknop zelf wordt afgevangen door stopPropagation */
              if (card.classList.contains('pb-expert-card--playing')) {
                stopPlay();
              } else {
                /* Stop andere afspelende cards */
                cards.forEach(function (other) {
                  if (other !== card && other.classList.contains('pb-expert-card--playing')) {
                    other.classList.remove('pb-expert-card--playing');
                    var ov = other.querySelector('.pb-expert-card__video');
                    var ob = other.querySelector('[data-pb-sound-btn]');
                    if (ov) { ov.muted = true; ov.pause(); ov.currentTime = 0; }
                    if (ob) updateSoundBtn(ob, true);
                  }
                });
                startPlay();
              }
            });
          } else {
            /* Desktop: hover */
            card.addEventListener('mouseenter', startPlay);
            card.addEventListener('mouseleave', stopPlay);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initExpertCards);
    } else {
      initExpertCards();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
